import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingPier = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Pier1"];
    return BF2GetConfigBasedOutskirtBuilding(config, false, 1);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingPier.ts
// module id = 2168
// module chunks = 3